import React from 'react';
import {NavLink} from 'react-router-dom';
import {FaFacebookSquare, FaInstagram,FaTwitter,FaMobileAlt,FaMapMarkedAlt} from 'react-icons/fa';
import {HiMail} from 'react-icons/hi';
import bg from '../../images/logo.png';
import './css/footer.css';

const Footer = () => {
  return (
    <footer>
      <div className='footer-main'>
        <div className='footer-inner'>
          <div>
          <NavLink to='/'>
            <img src={bg} alt='everest thinkers' width='250' height='76' />          
          </NavLink>
            <p>Lorem Ipsum is simply dummy text of the change and typesetting industry. </p>
            <div className='socialmedia_icons'>
                <li><a href='https://www.facebook.com/'><i ><FaFacebookSquare /></i> </a></li>
                <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                <li><a href='https://www.youtube.com/'><FaTwitter /></a></li>
                <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                {/**social ions */}
            </div>
          </div>
          <div>
          <p>quick links</p>
            <ul>
              <li>
              <NavLink to='/'>home</NavLink>
              </li>
              <li>
              <NavLink to='/gallery'>gallery</NavLink>
              </li>
              <li>
              <NavLink to='/about'>about</NavLink>
              </li>
              <li>
              <NavLink to='/projects'>projects</NavLink>
              </li>
              <li>
              <NavLink to='/contact'>contact</NavLink>
              </li>              
            </ul>
          </div>
          <div>
            <p>contact details</p>
            <ul>
                <li><a href='mailto:everestthinkers@gmail.com'><HiMail /> harshitha@gmail.com</a></li>
                <li><a href='tel:123456789'><FaMobileAlt /> 123456789</a></li>
                <li><a href='https://goo.gl/maps/GSFAgXXyS5gxvidk7' ><FaMapMarkedAlt /> vijayawada, Andhra Pradesh.</a></li>
            </ul>
        </div>
        </div>
      </div>
      <div className='copy_rights'>
        <p>© 2020 harshitha developers. All Rights Reserved.</p>
      {/**   <p>Terms & Conditions | Privacy Policy</p>*/}
      </div>
    </footer>
  );
};

export default Footer;
